export const openNewTab = (path) => {
  const location = window.location;
  const url = location.protocol + '//' + location.host + path;
  window.open(url, '_blank');
};
